const LoadingComponent = () => {
  return (
    <div className="flex w-full h-full items-center justify-center gap-5">
      <div className="w-16 h-16 rounded-full overflow-hidden animate-spin bg-white">
        <img
          src="/logo.png"
          alt="Spinning"
          className="w-full h-full object-contain"
        />
      </div>
      <span className="animate-pulse">Loading ...</span>
    </div>
  );
};

export default LoadingComponent;